import { useEffect } from 'react';

import { isEqual } from 'lodash/fp';
import { useLocation, useNavigate } from 'react-router-dom';

import { useSwapContext } from '@/pages/Swap/context';
import { NavigationLinks, useMainNavigationStore } from '@/shared';
import { findTokenCombinationFromUrl } from '@/utils/findTokenCombinationFromUrl';

export const useMainNavigation = (initialState?: NavigationLinks) => {
  const { pathname } = useLocation();
  const isPgWallet = pathname.includes('pg-wallet');
  const { tokenFrom, tokenTo } = useSwapContext();
  const { currentNav, setCurrentNav } = useMainNavigationStore();
  const navigate = useNavigate();

  useEffect(() => {
    const [firstToken, secondToken] = findTokenCombinationFromUrl(pathname);

    if (!currentNav && initialState) {
      setCurrentNav(initialState);
    }

    if (currentNav && [NavigationLinks.SWAP].includes(currentNav)) {
      if (!isEqual([firstToken, secondToken], [tokenFrom, tokenTo])) {
        onNavChange(currentNav || '', true);
      }
    }
  }, [tokenFrom, tokenTo, currentNav]);

  const onNavChange = (nextNav: string, replace?: boolean): void => {
    const navLink = nextNav as NavigationLinks;
    setCurrentNav(navLink);

    if (navLink === NavigationLinks.SWAP) {
      navigate(`${isPgWallet ? '/pg-wallet/' : '/'}`.concat(navLink.toLowerCase(), '/', tokenFrom, '-', tokenTo), {
        replace,
      });
    } else {
      navigate(`${isPgWallet ? '/pg-wallet' : ''}/${navLink.toLowerCase()}`, { replace });
    }
  };

  return { currentNav, onNavChange };
};
